import { render, staticRenderFns } from "./ProductViewDetail.vue?vue&type=template&id=d2da1d56&scoped=true&"
import script from "./ProductViewDetail.vue?vue&type=script&lang=js&"
export * from "./ProductViewDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductViewDetail.vue?vue&type=style&index=0&id=d2da1d56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2da1d56",
  null
  
)

export default component.exports